import { isAfter, isBefore } from 'date-fns';

import { PricingProfileStatus } from 'pricing/components/PricingProfileList/enums';
import { IPricingProfile } from 'pricing/types';

export const getStatus = (data: IPricingProfile) => {
  if (data.startDate && isAfter(new Date(data.startDate), new Date())) {
    return PricingProfileStatus.INACTIVE;
  }

  if (data.endDate && isBefore(new Date(data.endDate), new Date())) {
    return PricingProfileStatus.INACTIVE;
  }

  return PricingProfileStatus.ACTIVE;
};
